import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';
import {
  AudienceContext,
  View,
} from '@/features/editor/widgets/shared/modals/audience/audience-context';
import {
  CustomAudienceBtn,
  CustomQB,
} from '@/features/editor/widgets/shared/modals/audience/custom-audience';
import { LineItem } from '@/features/editor/widgets/shared/modals/audience/audience-shared';
import { FacebookLineItem } from '@/features/editor/widgets/shared/modals/audience/facebook-audience/line-item';
import { BackModalHeader } from '@/features/editor/widgets/shared/modals/commons';
import {
  FacebookContainer,
  FacebookHeader,
} from '@/features/editor/widgets/shared/modals/audience/facebook-audience/container';
import { EditorContext } from '@/features/editor/context/editor-context';
import { Segment } from '@/webapi/use-experience-api';

export function AudienceModalBody() {
  const { view } = useContext(AudienceContext);
  switch (view) {
    case View.CUSTOM:
      return <CustomQB />;
    case View.FACEBOOK:
      return <FacebookContainer />;
    default:
      return <AudienceSelection />;
  }
}

export function AudienceModalHeader() {
  const { view, onBackToSelection } = useContext(AudienceContext);
  switch (view) {
    case View.CUSTOM:
      return (
        <BackModalHeader
          back={onBackToSelection}
          header="Build a Custom Audience"
        />
      );
    case View.FACEBOOK:
      return <FacebookHeader back={onBackToSelection} />;
    default:
      return <>Choose the audience that will see the experience</>;
  }
}

function AudienceSelection() {
  const {
    resources,
    experienceState: {
      currentExperience: { isPostPurchase },
    },
  } = useContext(EditorContext);
  const { onPredefined, onCustom, selected, audiences, onAllVisitors, view } =
    useContext(AudienceContext);
  return (
    <>
      <CustomAudienceBtn onClicked={onCustom} />
      <span>Or choose from these predefined audiences</span>
      <Grid>
        <LineItem
          key="all"
          selected={!(view === View.CUSTOM) && selected.length === 0}
          onClicked={onAllVisitors}
        >
          <span>All Users</span>
          <span>Everyone that browses your store</span>
        </LineItem>
        <FacebookLineItem disabled={isPostPurchase} />
        {audiences.map((audience) => (
          <LineItem
            disabled={isPostPurchase}
            key={audience.kind}
            selected={!!selected.find((s) => s === audience.kind)}
            onClicked={(_, value) => onPredefined(value, audience.kind)}
          >
            <span>{audience.name}</span>
            <span>{audience.description}</span>
          </LineItem>
        ))}
      </Grid>
      {resources?.customerTags?.length > 0 ? (
        <>
          <span>Shopify Segments</span>
          <Grid>
            {resources?.customerTags?.map((v) => (
              <LineItem
                key={v}
                selected={!!selected.find((s) => s === `CUSTOMER_TAG__${v}`)}
                onClicked={(_, value) =>
                  onPredefined(
                    value,
                    `CUSTOMER_TAG__${v}` as unknown as Segment,
                  )
                }
              >
                <span style={{ maxWidth: `255px`, overflow: `hidden` }}>
                  {v}
                </span>
                <span style={{ maxWidth: `255px`, overflow: `hidden` }}>
                  Logged in customers tagged with {`"${v}"`}
                </span>
              </LineItem>
            ))}
          </Grid>
        </>
      ) : null}
    </>
  );
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  width: 100%;
  grid-gap: 2.5rem;
`;
